import React from 'react';

import { useMachine } from '@xstate/react';
import { useSearchParams } from 'react-router-dom';

import { OpsiumUser } from '@/modules/common/types/opsium-user';
import { useRootActorRef } from '@/router/state/root/util/context/helpers';

import { ConfirmResetPasswordForm } from '../components/confirm-reset-password-form';
import { EmailSentMessage } from '../components/email-sent-message';
import { ResetPasswordForm } from '../components/reset-password-form';
import {
  ResetPasswordEvents,
  resetPasswordMachine,
  ResetPasswordStates,
} from '../state/reset-password-machine';

export const ResetPasswordPage: React.FC = () => {
  const rootActorRef = useRootActorRef();

  const [searchParams] = useSearchParams();
  const email = searchParams.get('email');
  const code = searchParams.get('code');

  const [state, send] = useMachine(resetPasswordMachine, {
    input: { email, code },
  });

  const renderContent = () => {
    if (state.matches(ResetPasswordStates.ConfirmResetPassword)) {
      return (
        <ConfirmResetPasswordForm
          email={state.context.email!}
          code={state.context.code!}
          onSuccess={(user: OpsiumUser) => {
            rootActorRef.send({ type: 'LOGGED_IN', user });
          }}
        />
      );
    } else if (state.matches(ResetPasswordStates.ResetPassword)) {
      return <ResetPasswordForm onSuccess={() => send({ type: ResetPasswordEvents.EmailSent })} />;
    } else if (state.matches(ResetPasswordStates.EmailSentMessage)) {
      return <EmailSentMessage />;
    }
    return null;
  };

  return (
    <div className="flex min-h-screen flex-1 flex-col items-center justify-center p-8">
      {renderContent()}
    </div>
  );
};
